import { render } from "./ManualDonation.vue?vue&type=template&id=423b347f&scoped=true"
import script from "./ManualDonation.vue?vue&type=script&lang=js"
export * from "./ManualDonation.vue?vue&type=script&lang=js"

import "./ManualDonation.vue?vue&type=style&index=0&id=423b347f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423b347f"]])

export default __exports__